import variables from '../variables'

const { animation } = variables

const layout = {
  sideTransition: `all ${animation.duration} ${animation.curveDefault}`,
}

export default layout
